import { useState, useEffect } from 'react';

/**
 * Returns true while the given CSS media query matches.
 * Re-evaluates whenever the viewport changes.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    // Use addEventListener if available (modern), fall back to addListener
    mql.addEventListener('change', handler);
    // Sync immediately in case the query changed between render and effect
    setMatches(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
